import { useState } from "react";
import { createContext } from "react";

export const NavContext = createContext({
    currentNavigationPath: "",
    setNavigationPath: () => null,
}
);

export const NavigationProvider = ({children}) => {
    const [currentNavigationPath, setNavigationPath] = useState(null);
    const value = {currentNavigationPath, setNavigationPath};
    return <NavContext.Provider value={value}>{children}</NavContext.Provider>
};

